import { useEffect, useState } from "react";

/**
 * Shown only while a route's code chunk is still downloading.
 *
 * It waits 150ms before appearing so fast navigations (and prefetched routes,
 * which resolve instantly) never flash an indicator, and it reserves the full
 * viewport height so the footer doesn't jump as the page arrives.
 */
export function RouteFallback() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = window.setTimeout(() => setVisible(true), 150);
    return () => window.clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen" aria-busy="true" aria-live="polite">
      <span className="sr-only">Loading page</span>
      {visible && (
        <div className="fixed inset-x-0 top-0 z-[60] h-0.5 overflow-hidden bg-transparent">
          <div className="h-full w-1/3 animate-route-progress bg-gradient-to-r from-primary/40 via-primary to-primary/40" />
        </div>
      )}
    </div>
  );
}
